import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

const FormControlLabelStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 5px',
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    width: '100%'
  }
});

const LinkButtonStyle = () => ({
  paddingLeft: '5px!important',
  '& .MuiButton-startIcon': {
    marginRight: '9px'
  },
  '&.Mui-disabled': {
    border: 'none'
  }
});

const RadioGroupStyle = () => ({
  width: 'fit-content',
  gap: '24px'
});

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const FieldContainerStyled = styled('div')(FieldContainerStyle);
export const Wrapper = styled(Stack)(WrapperStyle);
export const FormControlLabelStyled = styled(FormControlLabel)(FormControlLabelStyle);
export const RadioGroupStyled = styled(RadioGroup)(RadioGroupStyle);
export const LinkButtonStyled = styled(Button)(LinkButtonStyle);
